import { isAction, Middleware } from '@reduxjs/toolkit';

const deferredActions = new WeakSet<object>();

export const deferApiRegistrationMiddleware: Middleware =
  (store) => (next) => (action) => {
    if (
      isAction(action) &&
      action.type.endsWith('/config/middlewareRegistered') &&
      !deferredActions.has(action)
    ) {
      deferredActions.add(action);
      queueMicrotask(() => store.dispatch(action));
      return action;
    }
    return next(action);
  };
